'use client';

export const PROFILE_UPDATED_EVENT = 'botgo:profile-updated';
export const OPEN_SETTINGS_EVENT = 'botgo:open-settings';

export function notifyProfileUpdated(profile) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(PROFILE_UPDATED_EVENT, {
    detail: profile || null,
  }));
}

export function requestAccountSettings() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_SETTINGS_EVENT, {
    detail: { tab: 'account' },
  }));
}
